module.exports = __webpack_public_path__ + "static/wheel-box-bg.ef6e4d73.png";